<script>
import { mapGetters } from "vuex";

import Contract from "./Contract.vue";
import Offer from "./Offer.vue";

export default {
  name: "ContractWrapper",

  computed: {
    ...mapGetters({
      orgId: "Organizations/ActiveOne/getId",
      isContractOffer: "Organizations/ActiveOne/isContractOffer",
    }),
  },

  render: function (h) {
    if (this.isContractOffer) {
      return h(Offer);
    } else {
      return h(Contract);
    }
  },
};
</script>
